import $ from 'jquery';
import debounce from 'lodash/debounce';

// Adds a 'disabled' class to elements with [data-appear-disabled] when their
// parent form is not valid. This allows us to have submit buttons that "appear"
// disabled, withot interfering with normal browser behaviour and validation.
//
// Eg: <button type="submit" data-appear-disabled>Submit</button>

const appearDisabled = function() {
  $('[data-appear-disabled]').each(toggleDisabled);
};

const toggleDisabled = function() {
  const isFormValid = $(this)
    .closest('form')[0]
    .checkValidity();
  $(this).toggleClass('disabled', !isFormValid);
};

$(() => {
  if (!$('[data-appear-disabled]').length) return;
  $(appearDisabled);
  $('body').on('change input', debounce(appearDisabled));
});
